{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Bạn đã vượt quá giới hạn cuộc hội thoại. Gói Hacker chỉ cho phép 500 cuộc hội thoại.",
      "INBOXES": "Bạn đã vượt quá giới hạn hộp thư đến. Gói Hacker chỉ hỗ trợ trò chuyện trực tiếp trên website. Các hộp thư đến bổ sung như email, WhatsApp,... yêu cầu gói trả phí.",
      "AGENTS": "Bạn đã vượt quá giới hạn tổng đài viên. Gói Hacker chỉ cho phép 2 tổng đài viên.",
      "NON_ADMIN": "Vui lòng liên hệ quản trị viên của bạn để nâng cấp gói và tiếp tục sử dụng tất cả các tính năng."
    },
    "TITLE": "Cài đặt tài khoản",
    "SUBMIT": "Cập nhật cài đặt",
    "BACK": "Trờ về",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Không thể cập nhật cài đặt, hãy thử lại!",
      "SUCCESS": "Đã cập nhật thành công cài đặt tài khoản"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Xoá tài khoản của bạn",
      "NOTE": "Khi bạn xoá tài khoản, tất cả dữ liệu của bạn sẽ bị xoá.",
      "BUTTON_TEXT": "Xoá tài khoản của bạn",
      "CONFIRM": {
        "TITLE": "Xoá tài khoản",
        "MESSAGE": "Xoá tài khoản của bạn là không thể hoàn tác. Nhập tên tài khoản của bạn bên dưới để xác nhận rằng bạn muốn xoá vĩnh viễn.",
        "BUTTON_TEXT": "Xoá",
        "DISMISS": "Huỷ",
        "PLACE_HOLDER": "Nhập {accountName} để xác nhận"
      },
      "SUCCESS": "Tài khoản đã được đánh dấu để xoá",
      "FAILURE": "Không thể xoá tài khoản, hãy thử lại!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Tài khoản này được lên lịch xoá vào ngày {deletionDate}. Yêu cầu này được thực hiện bởi quản trị viên. Bạn có thể huỷ việc xoá trước ngày này.",
        "MESSAGE_INACTIVITY": "Tài khoản này được lên lịch xoá vào ngày {deletionDate} do không hoạt động. Bạn có thể huỷ việc xoá trước ngày này.",
        "CLEAR_BUTTON": "Huỷ lịch xoá"
      }
    },
    "FORM": {
      "ERROR": "Vui lòng sửa lỗi biểu mẫu",
      "GENERAL_SECTION": {
        "TITLE": "Cài đặt chung",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Tài khoản SID",
        "NOTE": "ID này là bắt buộc nếu bạn đang xây dựng tích hợp dựa trên API"
      },
      "NAME": {
        "LABEL": "Tên tài khoản",
        "PLACEHOLDER": "Tên tài khoản của bạn",
        "ERROR": "Vui lòng nhập tên tài khoản hợp lệ"
      },
      "LANGUAGE": {
        "LABEL": "Ngôn ngữ",
        "PLACEHOLDER": "Tên tài khoản của bạn",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Tên miền email đến",
        "PLACEHOLDER": "Miền mà bạn sẽ nhận được email",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Email hỗ trợ",
        "PLACEHOLDER": "Email hỗ trợ của công ty bạn",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Số ngày sau đó mà vé sẽ tự động giải quyết nếu không có hoạt động nào",
        "NOTE": "Số giờ không hoạt động sau đó bất kỳ cuộc hội thoại đang mở nào sẽ được tự động giải quyết.",
        "PLACEHOLDER": "30",
        "ERROR": "Vui lòng điền thời lượng tự động giải quyết hợp lệ (tối thiểu 1 ngày và tối đa 999 ngày)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Số ngày sau đó một cuộc hội thoại trống sẽ tự động giải quyết nếu không có hoạt động",
        "PLACEHOLDER": "không bao giờ",
        "ERROR": "Vui lòng điền thời lượng tự động giải quyết hợp lệ (tối thiểu 1 ngày và tối đa 999 ngày)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Tính liên tục của cuộc trò chuyện với email được kích hoạt cho tài khoản của bạn.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Bạn có thể nhận email trong miền tùy chỉnh của mình ngay bây giờ."
      },
      "PHONE": {
        "TITLE": "Cài đặt PBX",
        "NOTE": "Cấu hình kết nối đến PBX của bạn cho các cuộc gọi điện thoại",
        "SIP_HOST": {
          "LABEL": "Tên miền SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Chế độ gọi",
          "MODES": {
            "direct": "Trực tiếp - cuộc gọi được quay số ngay khi nhấp vào liên kết điện thoại",
            "indirect": "Gián tiếp - số điện thoại được chuẩn bị sẵn trong ô nhập của widget điện thoại"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Quyền truy cập bản ghi âm cuộc gọi",
          "MODES": {
            "admin_only": "Chỉ quản trị viên",
            "admin_and_assigned_agent": "Quản trị viên và tổng đài viên được phân công",
            "inbox_members": "Tất cả tổng đài viên có quyền truy cập hộp thư đến"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Cài đặt Email",
        "NOTE": "Thay đổi hành vi của các hộp thư đến email"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Chế độ hiển thị dấu thời gian cuộc hội thoại",
        "MODES": {
          "both": "Ngày tạo và hoạt động gần nhất",
          "last_activity_only": "Chỉ hoạt động gần nhất",
          "last_customer_message": "Tin nhắn cuối của khách hàng"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Chặn tên miền có uy tín thấp"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Bao gồm tin nhắn gốc trong phản hồi email"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Tự động giải quyết cuộc hội thoại mới"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Tự động chuyển cuộc hội thoại email mới sang hộp thư của robot đã xử lý đơn hàng của liên hệ"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Nhãn mở rộng - Cho phép tên nhãn dài hơn với giao diện popup lớn hơn"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Tự động gán cuộc hội thoại cho tổng đài viên đã tạo câu trả lời cuối cùng"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Chế độ thông báo đẩy",
        "MODES": {
          "all_inboxes": "Tất cả hộp thư đến - Gửi thông báo cho tất cả loại kênh",
          "chat_only": "Chỉ trò chuyện - Chỉ gửi thông báo cho các kênh không phải email"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Cho phép bật/tắt chữ ký trên tin nhắn đã gửi"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Hiển thị trạng thái trò chuyện của tổng đài viên trên Wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Hiển thị đầy đủ tên tệp đính kèm không rút gọn"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Đăng nhập bằng mật khẩu",
        "MODES": {
          "allowed_for_all": "Cho phép với tất cả người dùng",
          "allowed_for_agents_only": "Chỉ cho phép với tổng đài viên (quản trị viên phải dùng OAuth)",
          "password_login_disabled": "Đã tắt - Chỉ OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Đã có phiên bản mới. Tải lại để nhận các cập nhật mới nhất.",
    "RELOAD_NOW": "Cập nhật ngay",
    "LEARN_MORE": "Tìm hiểu thêm",
    "PAYMENT_PENDING": "Khoản thanh toán của bạn đang chờ xử lý. Vui lòng cập nhật thông tin thanh toán để tiếp tục sử dụng trung tâm liên lạc",
    "LIMITS_UPGRADE": "Tài khoản của bạn đã vượt quá giới hạn sử dụng, vui lòng nâng cấp gói để tiếp tục sử dụng trung tâm liên lạc",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Bấm enter để chọn",
      "ENTER_TO_REMOVE": "Bấm enter để xoá",
      "NO_OPTIONS": "Danh sách trống",
      "NO_RESULT": "Không tìm thấy kết quả",
      "SELECT_ONE": "Chọn một",
      "SELECT": "Chọn"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Thông báo",
    "MARK_ALL_DONE": "Đánh dấu tất cả đã xong",
    "DELETE_TITLE": "đã xoá",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Thông báo tin chưa đọc",
      "ALL_NOTIFICATIONS": "Xem tất cả thông báo",
      "LOADING_UNREAD_MESSAGE": "Đang tải thông báo tin chưa đọc...",
      "EMPTY_MESSAGE": "Bạn không có thông báo tin chưa đọc"
    },
    "LIST": {
      "LOADING_MESSAGE": "Đang tải thông báo...",
      "404": "Không có thông báo",
      "TABLE_HEADER": [
        "Tên",
        "Số điện thoại",
        "Các cuộc hội thoại",
        "Liên hệ lần cuối"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Hội thoại mới mới",
      "conversation_assignment": "Hội thoại đã được phân công",
      "assigned_conversation_new_message": "Tin nhắn mới",
      "participating_conversation_new_message": "Tin nhắn mới",
      "conversation_mention": "Nhắc đến",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Không Trực Tuyến",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Làm mới"
    },
    "CONNECTION_LOST": {
      "TITLE": "Mất kết nối",
      "DESCRIPTION": "Chúng tôi không thể kết nối tới máy chủ. Hãy kiểm tra kết nối và thử lại.",
      "RETRY": "Thử lại"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Tìm kiếm hoặc nhảy đến",
    "SECTIONS": {
      "GENERAL": "Chung",
      "REPORTS": "Báo cáo",
      "CONVERSATION": "Hội thoại",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Thay đổi người được phân công",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Thay đổi nhóm",
      "SNOOZE_CONVERSATION": "Tạm dừng \bhội thoại",
      "EXECUTE_MACRO": "Thực thi Macro",
      "ADD_LABEL": "Thêm nhãn vào hội thoại",
      "REMOVE_LABEL": "Xoá nhãn khỏi hội thoại",
      "SETTINGS": "Cài đặt",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Đi tới Trang tổng quan hội thoại",
      "GO_TO_CONTACTS_DASHBOARD": "Đi tới Trang tổng quan liên hệ",
      "GO_TO_REPORTS_OVERVIEW": "Đi đến Tổng quan Báo cáo",
      "GO_TO_CONVERSATION_REPORTS": "Đi tới Trang Báo cáo hội thoại",
      "GO_TO_AGENT_REPORTS": "Đi đến Báo cáo Tổng đài viên",
      "GO_TO_LABEL_REPORTS": "Đi đến Báo cáo Nhãn",
      "GO_TO_INBOX_REPORTS": "Đi đến Báo cáo Kênh",
      "GO_TO_TEAM_REPORTS": "Đi đến Báo cáo Nhóm",
      "GO_TO_SETTINGS_AGENTS": "Đi đến Cài đặt Tổng đài viên",
      "GO_TO_SETTINGS_TEAMS": "Đi đến Cài đặt Nhóm",
      "GO_TO_SETTINGS_INBOXES": "Đi đến Cài đặt Kênh",
      "GO_TO_SETTINGS_LABELS": "Đi đến Cài đặt Nhãn",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Đi đến Cài đặt Tin trả lời mẫu",
      "GO_TO_SETTINGS_APPLICATIONS": "Đi đến Cài đặt Ứng dụng",
      "GO_TO_SETTINGS_ACCOUNT": "Đi đến Cài đặt Tài khoản",
      "GO_TO_SETTINGS_PROFILE": "Đi đến Cài đặt Hồ sơ",
      "GO_TO_NOTIFICATIONS": "Đi đến Thông báo",
      "ADD_LABELS_TO_CONVERSATION": "Thêm nhãn vào hội thoại",
      "ASSIGN_AN_AGENT": "Gán cho tổng đài viên",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Phân công một nhóm",
      "EXECUTE_A_MACRO": "Thực thi Macro",
      "MUTE_CONVERSATION": "Tắt tiếng hội thoại",
      "UNMUTE_CONVERSATION": "Bật tiếng hội thoại",
      "REMOVE_LABEL_FROM_CONVERSATION": "Xoá nhãn khỏi hội thoại",
      "REOPEN_CONVERSATION": "Mở lại hội thoại",
      "RESOLVE_CONVERSATION": "Giải quyết hội thoại",
      "SEND_TRANSCRIPT": "Gửi bản ghi qua email",
      "SNOOZE_CONVERSATION": "Tạm dừng \bhội thoại",
      "UNTIL_NEXT_REPLY": "Cho đến phản hồi kế tiếp",
      "UNTIL_NEXT_WEEK": "Cho đến tuần sau",
      "UNTIL_TOMORROW": "Cho đến ngày mai",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Đang tải dữ liệu..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "click vào đây"
  }
}
